import { cn } from '@/shared/lib'
import { Avatar, type AvatarSize } from '@/shared/ui/avatar'
import { DepartmentBadges } from '@/shared/ui/department-badge'
import type { Employee } from '../model/schema'

interface EmployeeChipProps {
  employee: Employee
  size?: Extract<AvatarSize, 'sm' | 'md'>
  className?: string
}

// Имя + аватар + (опц.) тихий ряд dept-дотов. Презентер сущности — без действий.
// Набор отделов — в самой проекции сотрудника (00-architecture § 2), не резолвим.
export function EmployeeChip({ employee, size = 'sm', className }: EmployeeChipProps) {
  return (
    <span className={cn('inline-flex min-w-0 items-center gap-2', className)}>
      <Avatar name={employee.name} size={size} />
      <span className="truncate text-sm text-text-primary">{employee.name}</span>
      <DepartmentBadges names={employee.departments} variant="dot" />
    </span>
  )
}
